module.exports = __webpack_public_path__ + "49aabfd0f406b59330fa04b9dd54fbff.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=410!./images/projekte/festival06.jpg
// module id = 515
// module chunks = 0